import { getApiErrorMessage } from "./getApiErrorMessage";

const requestErrorTreatment = (error: any, open: any) => {
  open?.({
    type: "error",
    message: getApiErrorMessage(error),
  });
};

export default requestErrorTreatment;
